<template>
  <v-container v-if="membershipsFiltered" density="compact" dense="true">
    <h1>Youth Programs</h1>
    <div class="d-flex ma-2 pa-2 ga-4">
      <div class="w-100 flex-column align-self-stretch">
        <v-card v-if="!!eiiCurrent">
          <v-card-title>Scholarship Information</v-card-title>

          <v-card-text>
            <h2>You have successfully applied for a scholarship.</h2>
            <p>Current Price: {{ formatCost(eiiCurrent.priceCents / 100) }}</p>
            <p>
              Household Income:
              {{ formatCost(eiiCurrent.householdIncomeCents / 100) }}
            </p>
            <p>Working Adults: {{ eiiCurrent.workingAdults }}</p>
            <p>Dependent Adults: {{ eiiCurrent.nonWorkingAdults }}</p>
            <p>Children: {{ eiiCurrent.children }}</p>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-title>Scholarship Application</v-card-title>
          <v-card-text>Application for sliding scale scholarship.</v-card-text>
          <v-card-actions
            ><v-spacer /><v-btn
              :loading="eiiLoading"
              to="/scholarship"
              variant="tonal"
              color="primary"
              >Begin Application</v-btn
            ></v-card-actions
          >
        </v-card>
        <v-card class="mt-4">
          <v-card-title>Children</v-card-title>
          <v-card-text>
            <PersonChildrenTable
              v-if="isAuthenticated && !authStore.isProtoMember"
              @person-selected-id="(value) => (personSelectedId = value)"
              membership-options-action
            /><!--@update-person="updatePerson"-->
            <p v-else-if="authStore.isProtoMember">
              Guest sessions cannot add household members. Log in to an existing
              account or complete guest checkout first.
            </p>
            <p v-else>
              Please create an account and add a child to purchase a junior
              membership
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              v-if="!authStore.isProtoMember"
              to="/manage-children"
              variant="tonal"
              color="primary"
              >Manage or Add Children</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>
      <v-card class="pb-4 w-100">
        <v-card-title>Memberships</v-card-title>
        <v-card-text
          ><v-select
            label="Select a child"
            :items="selectOptions"
            v-model="personSelectedId"
        /></v-card-text>
        <v-col v-for="membershipType in membershipsFiltered">
          <MembershipTypeCard
            :membership-type="membershipType"
            :person="selectedPerson"
            require-person
          />
        </v-col>
      </v-card>
    </div>
  </v-container>
  <v-progress-linear v-else indeterminate />
</template>

<script lang="ts" setup>
import { useRoute } from "vue-router";
import { useAppData } from "@/composables/useAppData";
import { PersonTypeEnum } from "@/autogen";
import type { EiiApplication } from "../../../cbi-generator/generated/dto/EiiApplication";
import { useEiiService } from "../../../cbi-generator/frontend/composables/useEiiFrontendService";
import { usePersonTypeMask } from "@/composables/usePersonTypeMask";
import { useUser } from "@/composables/useUser";
import { useUtility } from "@/composables/useUtility";
import { useAuthStore } from "@/stores/auth";
import { PersonNameInfoClass } from "@/api/dto/PersonNameInfo";
import { useMembershipPurchaseOptions } from "@/composables/shop/useMembershipPurchaseOptions";
const route = useRoute();
const { formatCost } = useUtility();
const eiiCurrent = ref<EiiApplication | null>(null);
const eiiLoading = ref(false);
const auth = useAuthStore();
const isAuthenticated = computed(() => auth.isAuthenticated());
onMounted(() => {
  if (isAuthenticated.value) {
    eiiLoading.value = true;
    useEiiService()
      .currentApplicationMember()
      .then((status) => {
        eiiCurrent.value = status.application;
      })
      .finally(() => {
        eiiLoading.value = false;
      });
  }
});
const isLoadingRef = ref(false);
const isLoading = computed(() => isLoadingRef.value || userStore.loading.value);
const typeMask = usePersonTypeMask(PersonTypeEnum.JUNIOR_MEMBER);
const appData = useAppData();
const authStore = useAuthStore();
const userStore = useUser();
const children = userStore.currentChildrenRef;
const selectOptions = computed(() => {
  return children.value?.map((a) => {
    return {
      title: new PersonNameInfoClass(a).getFullName(),
      value: a.personId,
    };
  });
});
function idFromParam() {
  if (typeof route.params.id == "string") {
    const id = parseInt(route.params.id);
    if (isNaN(id)) return undefined;
    return id;
  }
  return undefined;
}
const personSelectedId = ref(idFromParam());
const selectedPerson = computed(() =>
  children.value.find((child) => child.personId == personSelectedId.value),
);
const membershipsFiltered = useMembershipPurchaseOptions(2);

//const membershipTypeName = appData.membershipTypes
//const membershipTypeDescription = appData.membershipTypeDiscounts
</script>
